import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  discount: {
    padding: theme.spacing(5)
  },
  inactive: {
    backgroundColor: theme.colorPalette.green_100
  },
  section: {
    display: 'flex',
    alignItems: 'center'
  },
  labelSection: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '55%'
  },
  info: {
    height: 24,
    width: 24
  },
  telematicsTooltip: {
    height: 24,
    width: 24,
    paddingLeft: 0
  },
  savings: {
    fontSize: 12,
    marginRight: theme.spacing(2)
  },
  button: {
    boxShadow: 'none'
  },
  editIcon: {
    height: 24,
    width: 24,
    '& > img': {
      height: 24,
      width: 24
    }
  },
  iconContainer: {
    height: 24,
    width: 24,
    padding: 0
  },
  arrow: {
    height: 20,
    width: 20
  }
});

export default makeStyles(styles);
